import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { services } from "../../app/services";
import { ServiceDocumentationItem } from "../../components/subscription-detail/shortcut-menu/items/service-documentation/service-documentation";
import { mapToProductType } from "../../helpers/enums/productType";

@Component({
  selector: "network-services-shortcut-menu",
  templateUrl: "network-services-shortcut-menu.html",
  styleUrls: ["../../components/subscription-detail/shortcut-menu/shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ServiceDocumentationItem, TranslatePipe],
})
export class NetworkServicesShortcutMenuComponent {
  public readonly productType = input.required<string>();
  protected readonly docsUrl = computed(() => {
    const type = mapToProductType(this.productType());
    return type ? services[type].docs : "";
  });
}
